import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import type { AiGenerateImageStyleType } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';

interface IGenerationStyleItem {
    name: string;
    image_url: string;
    key: AiGenerateImageStyleType;
}

const aiImageGenerationStylesDefault: IGenerationStyleItem[] = [
    {
        name: 'Картина маслом',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/oil.png',
        key: 'oil',
    },
    {
        name: 'Мультфильм',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/cartoon.png',
        key: 'cartoon',
    },
    {
        name: '3D',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/3d.png',
        key: '3d',
    },
    {
        name: 'Пиксель арт',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/pixel.png',
        key: 'pixel',
    },
    {
        name: 'Аниме',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/anime.png',
        key: 'anime',
    },
    {
        name: 'Киберпанк',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/cyberpunk.png',
        key: 'cyberpunk',
    },
    {
        name: 'Комикс',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/comic.png',
        key: 'comic',
    },
    {
        name: 'Фото',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/realism1.png',
        key: 'realism',
    },
];

const aiImageGenerationSuggestionDefault: string[] = ['Девушка из аниме', 'Пейзаж Фэнтези', 'Космический кот', 'Мужчина в стиле киберпанк'];

export const aiImageGenerationEnabled = isFeature('ai_image_generation_enabled');
export const aiImageGenerationSuggestion: string[] = getFeature('ai_image_generation_suggestion') || aiImageGenerationSuggestionDefault;
export const aiImageGenerationStyles: IGenerationStyleItem[] = getFeature('ai_image_generation_styles') || aiImageGenerationStylesDefault;
export const aiImageGenerationPaidLimit: number = getFeature('ai_image_generation_paid_limit') || 20;
export const aiImageGenerationFreeLimit: number = getFeature('ai_image_generation_free_limit') || 1;
